import {Font, Toggle} from '@pepsico-ds/ui';
import {TextInput, Dropdown} from '@/components/atoms';
import PropTypes from 'prop-types';

const blockDecimalAndNegative = (e) => {
  if (e.key === '-' || e.key === '.' || e.key === 'e' || e.key === 'E') {
    e.preventDefault();
  }
};

const blockDecimalAndNegativePaste = (e) => {
  const pasted = e.clipboardData?.getData('text') || '';
  if (
    pasted.includes('-') ||
    pasted.includes('.') ||
    pasted.includes('e') ||
    pasted.includes('E')
  ) {
    e.preventDefault();
  }
};

const renderEditField = (item, handlers, itemMap) => {
  if (item.key === 'salesMethod') {
    const currentValue = itemMap.salesMethod?.value || '';
    const selectedValue = currentValue
      ? handlers.salesMethodDropdownOptions.filter(
          (o) => o.id === currentValue || o.value === currentValue
        )
      : [];
    return (
      <Dropdown
        value={selectedValue}
        updateValue={(val) => {
          const selected = Array.isArray(val) ? val[0] : val;
          handlers.onSalesMethodChange(selected?.value || selected?.id || '');
        }}
        isJsonWrap={false}
        childList={handlers.salesMethodDropdownOptions}
        className='market-config-dropdown'
        isDark={true}
        isClearable={false}
        selection='single'
        size='medium'
        style={{width: '100%'}}
      />
    );
  }
  if (item.key === 'evaluationFrequency') {
    const currentValue = itemMap.evaluationFrequency?.value || '';
    const selectedValue = currentValue
      ? handlers.evaluationFrequencyDropdownOptions.filter(
          (o) => o.id === currentValue || o.value === currentValue
        )
      : [];
    return (
      <Dropdown
        value={selectedValue}
        updateValue={(val) => {
          const selected = Array.isArray(val) ? val[0] : val;
          handlers.onEvaluationFrequencyChange(
            selected?.value || selected?.id || ''
          );
        }}
        isJsonWrap={false}
        childList={handlers.evaluationFrequencyDropdownOptions}
        className='market-config-dropdown'
        isDark={true}
        isClearable={false}
        selection='single'
        size='medium'
        style={{width: '100%'}}
      />
    );
  }
  if (item.key === 'salesDays') {
    return (
      <TextInput
        value={itemMap.salesDays?.value || ''}
        onChange={(val) => handlers.onSalesDaysChange(val)}
        label={''}
        type='number'
        isDark={true}
        className='market-config-input'
        handleKeyDown={blockDecimalAndNegative}
        onPaste={blockDecimalAndNegativePaste}
      />
    );
  }
  if (item.key === 'includeOfflineOrders') {
    return (
      <Toggle
        value={itemMap.includeOfflineOrders?.value === true}
        updateValue={(val) => handlers.onIncludeOfflineOrdersChange(val)}
        uiSchema={{
          isDark: true,
          size: 'small',
          label: ''
        }}
      />
    );
  }
  return null;
};

export const MarketLevelConfigurations = ({
  configItems,
  isEditMode,
  onSalesMethodChange,
  onEvaluationFrequencyChange,
  onSalesDaysChange,
  onIncludeOfflineOrdersChange,
  salesMethodDropdownOptions,
  evaluationFrequencyDropdownOptions
}) => {
  const itemMap = {
    salesMethod: configItems.find((item) => item.key === 'salesMethod'),
    evaluationFrequency: configItems.find(
      (item) => item.key === 'evaluationFrequency'
    ),
    salesDays: configItems.find((item) => item.key === 'salesDays'),
    includeOfflineOrders: configItems.find(
      (item) => item.key === 'includeOfflineOrders'
    )
  };

  const handlers = {
    onSalesMethodChange,
    onEvaluationFrequencyChange,
    onSalesDaysChange,
    onIncludeOfflineOrdersChange,
    salesMethodDropdownOptions,
    evaluationFrequencyDropdownOptions
  };

  return (
    <div className='market-config-grid'>
      {configItems.map((item) => (
        <div key={item.key || item.label} className='market-config-item'>
          <Font
            variant='regular'
            size='small'
            textColorClass='text-gray-100'
            className='mb-1 block'>
            {item.label}
          </Font>
          {isEditMode && itemMap[item.key] ? (
            renderEditField(item, handlers, itemMap)
          ) : (
            <Font variant='bold' size='small' textColorClass='text-white'>
              {item.displayValue}
            </Font>
          )}
        </div>
      ))}
    </div>
  );
};

MarketLevelConfigurations.propTypes = {
  configItems: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string,
      displayValue: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool
      ]),
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool
      ])
    })
  ).isRequired,
  isEditMode: PropTypes.bool.isRequired,
  onSalesMethodChange: PropTypes.func.isRequired,
  onEvaluationFrequencyChange: PropTypes.func.isRequired,
  onSalesDaysChange: PropTypes.func.isRequired,
  onIncludeOfflineOrdersChange: PropTypes.func.isRequired,
  salesMethodDropdownOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      displayText: PropTypes.string,
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool
      ]),
      isBadge: PropTypes.bool
    })
  ).isRequired,
  evaluationFrequencyDropdownOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      displayText: PropTypes.string,
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool
      ]),
      isBadge: PropTypes.bool
    })
  ).isRequired
};
